import React from 'react'
import PropTypes from 'prop-types'
import {useIncrementingId} from '#hooks/useIncrementingId'

function InputNumber({
  value,
  placeholder,
  maxValue,
  minValue,
  onChangeHandle,
  labelText,
  modifier,
  disabled,
  autoFocus,
}) {
  const id = useIncrementingId()
  const modifiers = modifier
    ? modifier
        .split(' ')
        .map(m => `input--${m}`)
        .join(' ')
    : 0
  return (
    <div className={`input ${modifiers}`}>
      <label htmlFor={id}>
        {labelText}
        <input
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          id={id}
          disabled={disabled}
          name={name}
          max={maxValue}
          min={minValue}
          onChange={onChangeHandle ? elem => onChangeHandle(elem) : undefined}
          value={value}
          type="number"
          placeholder={placeholder}
        />
      </label>
    </div>
  )
}

InputNumber.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  onChangeHandle: PropTypes.func,
  labelText: PropTypes.string,
  modifier: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
}

export default InputNumber
